import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ClassNames from 'classnames'
import { Link } from 'react-router-dom'

class TitleCard extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isLargeTitleCardClosing: false,
      showLargeTitleCard: false,
    }

    this.mouseEnterTimeoutId = null
    this.mouseEnterTimeoutMilliseconds = 800

    this.handleAnimationEnd = this.handleAnimationEnd.bind(this)
    this.handleAnimationStart = this.handleAnimationStart.bind(this)
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.handlePosterOpenClick = this.handlePosterOpenClick.bind(this)
    this.hideLargeTitleCard = this.hideLargeTitleCard.bind(this)
    this.showLargeTitleCard = this.showLargeTitleCard.bind(this)
  }

  handleAnimationEnd(event) {
    if (event.animationName === 'closeLargeTitleCard') {
      this.setState({
        isLargeTitleCardClosing: false,
      })
    }
  }

  handleAnimationStart(event) {
    if (event.animationName === 'openLargeTitleCard') {
      this.setState({
        isLargeTitleCardClosing: true,
      })
    }
  }

  handleMouseEnter() {
    if (!this.props.posterOpened) {
      if (this.mouseEnterTimeoutId !== null) {
        clearTimeout(this.mouseEnterTimeoutId)
      }

      this.mouseEnterTimeoutId = setTimeout(() => {
        this.showLargeTitleCard()
      }, this.mouseEnterTimeoutMilliseconds)
    }
  }

  handleMouseLeave() {
    if (!this.props.posterOpened) {
      if (this.mouseEnterTimeoutId !== null) {
        clearTimeout(this.mouseEnterTimeoutId)

        this.mouseEnterTimeoutId = null
      }

      this.hideLargeTitleCard()
    }
  }

  handlePosterOpenClick(event) {
    this.hideLargeTitleCard()
    this.props.handlePosterOpenClick(event)
  }

  handleSmallTitleCardClick(event) {
    event.preventDefault()
  }

  hideLargeTitleCard() {
    this.setState({
      showLargeTitleCard: false,
    })
  }

  showLargeTitleCard() {
    this.setState({
      showLargeTitleCard: true,
    })
  }

  render() {
    const titleCardClassNames = ClassNames({
      'title-card': true,
      'title-card--large-active': this.state.showLargeTitleCard,
      'title-card--large-inactive': !this.state.showLargeTitleCard && this.state.isLargeTitleCardClosing,
      'title-card--focused': this.props.posterOpened && this.props.selectedTitle === this.props.id,
    })

    return (
      <div className={titleCardClassNames} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
        <div className="title-card__small">
          <Link className="title-card__small-watch-link" onClick={this.handleSmallTitleCardClick} to={`/watch/${this.props.videoId}`}>
            <div className="title-card__small-artwork" style={{ backgroundImage: `url("${this.props.artworkUrl}")`, }} />
          </Link>
          <div className="title-card__small-placeholder">
            <div className="title-card__small-placeholder-title">{this.props.name}</div>
          </div>
        </div>
        {this.props.posterOpened && this.props.selectedTitle === this.props.id &&
        <div className="title-card__focused-indicator">
          <div className="title-card__focused-indicator-border" />
          <div className="title-card__focused-indicator-hitzone-play">
            <Link className="title-card__focused-indicator-hitzone-play-button" to={`/watch/${this.props.videoId}`}>
              <div className="title-card__focused-indicator-hitzone-play-button-icon" />
            </Link>
          </div>
        </div>
        }
        <div className="title-card__large" onAnimationEnd={this.handleAnimationEnd} onAnimationStart={this.handleAnimationStart}>
          <div className="title-card__large-artwork" style={{ backgroundImage: `url("${this.props.artworkUrl}")`, }} />
          <div className="title-card__large-content">
            <div className="title-card__large-gradient-overlay" />
            <div className="title-card__large-info">
              <h3 className="title-card__large-info-title">{this.props.name}</h3>
              <p className="title-card__large-info-logline">{this.props.logline}</p>
            </div>
            <div className="title-card__large-border" />
            <div className="title-card__large-hitzone-play">
              <Link className="title-card__large-hitzone-play-button" to={`/watch/${this.props.videoId}`}>
                <div className="title-card__large-hitzone-play-button-icon" />
              </Link>
            </div>
            <div className="title-card__large-hitzone-poster" onClick={this.handlePosterOpenClick}>
              <div className="title-card__large-hitzone-poster-button">
                <div className="title-card__large-hitzone-poster-button-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

TitleCard.propTypes = {
  artworkUrl: PropTypes.string,
  logline: PropTypes.string,
  name: PropTypes.string,
  onPosterOpenClick: PropTypes.func,
  openPoster: PropTypes.func,
  posterOpened: PropTypes.bool,
  videoId: PropTypes.string,
}

TitleCard.defaultProps = {
  artworkUrl: '#',
  logline: '',
  name: '',
  posterOpened: false,
  videoId: '#',
}

export default TitleCard



// WEBPACK FOOTER //
// ./src/desktop/components/title-card/index.js